import { useEffect, useState } from 'react';

const getInitialMatch = (query, defaultValue) => {
  if (typeof window === 'undefined' || !window.matchMedia) return defaultValue;
  return window.matchMedia(query).matches;
};

const useMediaQuery = (query, defaultValue = false) => {
  const [matches, setMatches] = useState(() => getInitialMatch(query, defaultValue));

  useEffect(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return;
    const media = window.matchMedia(query);
    const handleChange = () => setMatches(media.matches);

    handleChange();
    if (media.addEventListener) {
      media.addEventListener('change', handleChange);
      return () => media.removeEventListener('change', handleChange);
    }
    media.addListener(handleChange);
    return () => media.removeListener(handleChange);
  }, [query]);

  return matches;
};

export default useMediaQuery;
